<template>
  <div class="home-game bg-ui-panel grey100--text d-flex">
    <v-row align="center" no-gutters class="game-card-layout">
      <v-col cols="8" class="pl-5">
        <div class="game-info mb-1">
          <div class="d-inline-block px-2 py-1 mb-2 font-weight-bold lh-1 text-caption green600 green100--text">
            <fai :icon="['fad', 'sparkles']" />
            NEW &amp; EPIC
          </div>
          <h3 class="text-uppercase grey100--text text-h6 font-weight-bold">
            Crate Battles
          </h3>
          <p class="text--secondary text-body-1">
            1v1, 2v2, Group Unboxing and more!
          </p>
        </div>


        <h5 class="game-stats text-body-1 text--secondary d-flex align-center">
          {{ active }} active
          <span class="mx-2">&middot;</span>
          <scrap :amount="won" class="mr-2 text--secondary" /> unboxed
        </h5>
      </v-col>

      <v-col cols="4" sm="3" lg="4" class="pos-relative">
        <v-img
          class="case"
          :src="require('@/assets/img/games/case-battles/crate-base.png')" contain
          max-width="144"
          width="90%" aspect-ratio="1"
        >
          <v-img
            class="pos-absolute sword sword-left"
            :src="require('@/assets/img/games/case-battles/sword-left.png')" contain
            max-width="154"
            width="100%" aspect-ratio="1"
          />
          <v-img
            class="pos-absolute sword sword-right"
            :src="require('@/assets/img/games/case-battles/sword-right.png')" contain
            max-width="154"
            width="100%" aspect-ratio="1"
          />
        </v-img>

        <BattleListingPlayer
          class="player player-1"
          no-tooltip
          :size="40"
          :player="{avatar: 'https://i.imgur.com/xNamCoM.jpg'}"
          color="#cd412b"
        />
        <BattleListingPlayer
          class="player player-2"
          no-tooltip
          :size="40"
          :player="{avatar: 'https://i.imgur.com/FpZ0kLq.png'}"
          color="#aade4e"
        />
        <BattleListingPlayer
          class="player player-3"
          no-tooltip
          :size="40"
          :player="{avatar: 'https://i.imgur.com/gTKsiiN.jpg'}"
          color="#3f99d7"
        />
        <BattleListingPlayer
          class="player player-4"
          no-tooltip
          :size="40"
          :player="{avatar: 'https://i.imgur.com/si6op9Q.png'}"
          color="#f1c40f"
        />

        <div class="rust-items">
          <v-img
            v-for="(item, i) in items"
            :key="i"
            class="case-item crate"
            :class="`item--${i + 1}`"
            :src="item" contain
            aspect-ratio="1"
          />
        </div>
      </v-col>
    </v-row>

    <div v-if="xpBonus > 1" class="xp-bonus px-2 py-2 font-weight-bold lh-1 text-caption green700 green200--text">
      +{{ (xpBonus - 1) * 100 | toLocale }}% XP
    </div>
  </div>
</template>

<script>
import BattleListingPlayer from '@/views/games/CaseBattles/components/BattleListingPlayer'

const ITEMS = [
  'https://i.imgur.com/2k42Bk1.png',
  'https://i.imgur.com/UsouMhB.png',
  'https://i.imgur.com/aDx5pzy.png',
]

export default {
  components: {
    BattleListingPlayer,
  },
  props: {
    stats: {
      type: Object,
      default: null,
    },
    conga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    active() {
      return this.stats?.active ?? 0
    },
    won() {
      return this.stats?.won ?? 0
    },
    xpBonus() {
      return this.conga?.games.caseBattles.xpMultiplier ?? 1
    },
    items() {
      return ITEMS
    },
  },
}
</script>

<style lang="scss" scoped>
.home-game {
  position: relative;
  height: 160px;
  cursor: pointer;
  transition: transform 0.3s ease;

  .game-card-layout {
    overflow: hidden;
    position: relative;
  }

  .case {
    overflow: visible;
    z-index: 2;
    transition: transform 0.3s ease;

    .sword {
      transition: transform 0.3s ease;
    }
  }

  ::v-deep .player {
    position: absolute;
    transition: transform 0.6s ease;
    transform: translate(-50%, -50%);

    @include xs() {
      display: none !important;
    }

    &.player-1 {
      top: 70%;
      left: -45px;
      transition-delay: 30ms;
    }

    &.player-2 {
      top: 20%;
      left: -35px;
      transition-delay: 100ms;
    }

    &.player-3 {
      top: 20%;
      right: 0;
      transition-delay: 60ms;
    }

    &.player-4 {
      top: 80%;
      right: 0;
    }
  }

  .game-info,
  .game-stats {
    transition: transform 0.6s ease;
  }

  .xp-bonus {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    background: gold;
    transform: translate(20%, -50%) rotate(-3deg);
  }

  .rust-items {
    @include overlay;

    pointer-events: none;

    .case-item {
      position: absolute;
      width: 50%;
      max-width: 100px;
      opacity: 0;
      transition: transform 0.5s ease, opacity 0.5s ease;

      &.crate {
        max-width: 50px;
      }

      &.item--1 {
        z-index: 1;
        top: 30%;
        left: 25%;
        transition-delay: 100ms;
        transform: translateY(50%) scale(0.8);
      }

      &.item--2 {
        z-index: 1;
        top: 2%;
        left: 0;
        transition-delay: 50ms;
        transform: translateY(50%) scale(0.8);
      }

      &.item--3 {
        z-index: 1;
        top: 5%;
        right: 30%;
        transform: translateY(50%) scale(0.8);
      }
    }
  }

  &:hover {
    transform: translateY(-3px);

    .case {
      transform: translateY(60%);
    }

    ::v-deep .player {
      transform: translate(-50%, 500%);
    }

    .sword.sword-left {
      transform: translate(75%, -75%);
    }

    .sword.sword-right {
      transform: translate(-50%, -75%);
    }

    .rust-items .case-item {
      opacity: 1;
      transform: translateY(0) translateX(0) scale(1);
    }

    .game-info {
      transform: translateX(24px) rotate(2deg) scale(1.1);
    }

    .game-stats {
      transform: translateX(24px) rotate(2deg) scale(1.1);
    }
  }
}
</style>
